<script setup>
import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';

const store = useStore();
const { t } = useI18n();

const settings = computed(
  () => store.getters['painel/getPainelSettings'] || {}
);
const webhookUrl = ref(settings.value?.human_attention_webhook_url || '');

watch(settings, v => {
  webhookUrl.value = v?.human_attention_webhook_url || '';
});

const save = async () => {
  await store.dispatch('painel/updateSettings', {
    human_attention_webhook_url: webhookUrl.value.trim(),
  });
};
</script>

<template>
  <div class="max-w-md space-y-3">
    <label class="block">
      <span class="text-xs uppercase text-n-slate-11">
        {{ t('PAINEL.CONFIGURACOES.HUMAN_ATTENTION.WEBHOOK_URL_LABEL') }}
      </span>
      <input
        v-model="webhookUrl"
        type="url"
        class="mt-1 w-full rounded border border-n-strong bg-n-surface-1 px-2 py-1"
      />
      <span class="mt-1 block text-xs text-n-slate-11">
        {{ t('PAINEL.CONFIGURACOES.HUMAN_ATTENTION.WEBHOOK_URL_HELPER') }}
      </span>
    </label>
    <button
      class="rounded bg-n-brand px-4 py-2 text-sm font-semibold text-white"
      @click="save"
    >
      {{ t('PAINEL.STATUS_CUSTOMIZATION.SAVE') }}
    </button>
  </div>
</template>
